import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useProtocols } from '../../../hooks/useProtocols';
import { useNotifications } from '../../NotificationSystem';
import './SetupWizardSteps.css';

const Step9Compliance = ({ stepData, onComplete, onValidation, structure }) => {
  const { notify } = useNotifications();
  const { t } = useTranslation('setup');
  const [protocols, setProtocols] = useState([]);
  const { protocols: existingProtocols } = useProtocols({});

  useEffect(() => {
    if (existingProtocols) {
      setProtocols(existingProtocols);
    }
  }, [existingProtocols]);

  const hasMinimumRequirements = protocols && protocols.length >= 1;

  const handleSkip = () => {
    if (!hasMinimumRequirements) {
      notify.error(t('step9.notifications.minimumNotMet'), t('step9.notifications.minimumNotMetTitle'));
      return;
    }
    onComplete({ skipped: true, hasMinimumRequirements: false });
  };

  return (
    <div className="step-content">
      <div className="step-section">
        <h3>{t('step9.title')}</h3>
        <p>{t('step9.description')}</p>
        <p>
          <strong>{t('step9.noteLabel')}</strong> {t('step9.noteText')}
        </p>
      </div>

      {!hasMinimumRequirements && (
        <div className="error-message" style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '6px' }}>
          {t('step9.completeStep7Warning')}
        </div>
      )}

      <div className="skip-section" style={{ marginTop: '32px', padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <p>{t('step9.skipDescription')}</p>
        {hasMinimumRequirements ? (
          <p style={{ marginTop: '12px', color: '#666', fontSize: '14px' }}>
            {t('step9.canSkipMessage')}
          </p>
        ) : (
          <p style={{ marginTop: '12px', color: '#856404', fontSize: '14px', fontWeight: '500' }}>
            {t('step9.cannotSkipMessage')}
          </p>
        )}
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSkip}
          disabled={!hasMinimumRequirements}
          style={{ marginTop: '16px', opacity: hasMinimumRequirements ? 1 : 0.5, cursor: hasMinimumRequirements ? 'pointer' : 'not-allowed' }}
        >
          {t('step9.skipForNow')}
        </button>
      </div>
    </div>
  );
};

export default Step9Compliance;
